const normalizeOrigin = (url) => {
  const raw = String(url || "").trim();
  if (!raw) return "";
  const noSlash = raw.replace(/\/+$/, "");
  return noSlash.replace(/\/api$/i, "");
};

const API_ORIGIN =
  normalizeOrigin(process.env.REACT_APP_API_ORIGIN) ||
  normalizeOrigin(process.env.REACT_APP_API) ||
  "";

export const resolveProfilePhoto = (raw, version) => {
  if (!raw) return "";
  const v = String(raw).trim();
  if (!v) return "";

  let url = v;
  if (!/^https?:\/\//i.test(v) && !v.startsWith("data:") && !v.startsWith("blob:")) {
    if (v.startsWith("/")) {
      // Prefer /api/uploads for production reverse-proxy compatibility.
      if (v.startsWith("/uploads/")) {
        if (API_ORIGIN) url = `${API_ORIGIN}/api${v}`;
        else if (typeof window !== "undefined") url = `${window.location.origin}/api${v}`;
        else url = v;
      } else if (API_ORIGIN) url = `${API_ORIGIN}${v}`;
      else if (typeof window !== "undefined") url = `${window.location.origin}${v}`;
      else url = v;
    } else {
      if (API_ORIGIN) url = `${API_ORIGIN}/uploads/${v}`;
      else if (typeof window !== "undefined") url = `${window.location.origin}/uploads/${v}`;
      else url = `/uploads/${v}`;
    }
  }

  if (version && !url.startsWith("data:") && !url.startsWith("blob:")) {
    const sep = url.includes("?") ? "&" : "?";
    return `${url}${sep}v=${encodeURIComponent(String(version))}`;
  }

  return url;
};
